export const environment = {
  production: true,
  name: '##{{environment}}##',
  api: '##{{api}}##',
  netApiUrl: '##{{netApiUrl}}##',
  payPalClientId: '##{{payPalClientId}}##',
  payPalCurrencyCode: '##{{payPalCurrencyCode}}##',
};